import {
  EVENT_NAME_CONTRACT_PURCHASE_VIEWED,
  PRODUCT_QUANTITIES_JOB_AD_QUANTITY,
} from 'src/app/v1/analytics';

export const getProductQuantities = (adBudgetPurchased: string): string[] => {
  if (adBudgetPurchased === EVENT_NAME_CONTRACT_PURCHASE_VIEWED) {
    const PRODUCT_QUANTITIES_CONTRACT_CATEGORY = '1';
    return [
      PRODUCT_QUANTITIES_JOB_AD_QUANTITY,
      PRODUCT_QUANTITIES_CONTRACT_CATEGORY,
    ];
  }

  return [PRODUCT_QUANTITIES_JOB_AD_QUANTITY];
};
